import styled from "styled-components";

export const MainDiv = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color:#646765;
    font-family: 'Helvetica Neue', Arial, sans-serif;
`;

export const ImgDiv = styled.div`
    width: 100%;
    height: 100vh;
    overflow: hidden;

    img{
        width: 100%;
        position: relative;
        top: -400px;
        filter: brightness(0.7); // затемнение для контраста с текстом
        @media(max-width: 1300px){
            top: -300px;
        }
        @media(max-width: 900px){
            top: -200px;
        }
        @media(max-width: 600px){
            top: 0;
        }
    }
`;

export const AboutDiv = styled.div`
    width: 70%;
    margin: 100px auto 80px auto;
    text-align: center;
    color: #f5f5f5;

    span{
        display: block;
        font-size: 48px;
        font-weight: 600;
        color: #ffffff;
        text-shadow: 2px 2px 10px rgba(0,0,0,0.5);
        margin-bottom: 40px;
        line-height: 1.2;
        transition: all 0.3s ease;

        @media(max-width: 1300px){
            font-size: 42px;
        }
        @media(max-width: 900px){
            font-size: 36px;
        }
        @media(max-width: 600px){
            font-size: 30px;
        }
    }

    p{
        max-width: 900px;
        margin: 0 auto;
        font-size: 20px;
        line-height: 1.8;
        text-align: justify;
        color: rgba(245, 245, 245, 0.95);
        font-weight: 400;
        letter-spacing: 0.5px;
        transition: all 0.3s ease;

        @media(max-width: 1300px){
            font-size: 19px;
        }
        @media(max-width: 900px){
            font-size: 18px;
        }
        @media(max-width: 600px){
            font-size: 16px;
        }

        span{
            line-height: 1.8;
        }
    }
`;
